export const data2_4 = [{
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Sub-Total 小计',
    name_code: "Sub_Total",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}];






// 22222222222222222




















// 3333333333333333333333
export const data4_3_6 = [{
    name: 'Top 20 OTA/TPI 第三方网络产量排名前二十位',
    name_code: "Top_20_OTA_TPI",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Top 40 Corporate Volume协议公司产量排名前四十位',
    name_code: "Top_40_Corporate_Volume",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Top 20 Government 政府单位产量排名前二十位',
    name_code: "Top_20_Government",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Top 20 MICE Account 会展公司产量排名前二十位',
    name_code: "Top_20_MICE_Account",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Top 20 Wholesaler Agent旅行社产量排名前二十位',
    name_code: "Top_20_Wholesaler_Agent",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Top Account Total 关键客户合计',
    name_code: "Top_Account_Total",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Hotel Rooms Revenue Total 酒店客房收入总计',
    name_code: "Hotel_Rooms_Revenue_Total",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Top Account Contribution % 关键客户贡献率百分比',
    name_code: "Top_Account_Contribution",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}]


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-3/data.js